import { render, staticRenderFns } from "./AutoSuggestionTextArea.vue?vue&type=template&id=1540f672&scoped=true"
import script from "./AutoSuggestionTextArea.vue?vue&type=script&lang=js"
export * from "./AutoSuggestionTextArea.vue?vue&type=script&lang=js"
import style0 from "./AutoSuggestionTextArea.vue?vue&type=style&index=0&id=1540f672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1540f672",
  null
  
)

export default component.exports